import { HttpHeaders } from '@angular/common/http';

export class HttpApiServiceBase {
   protected readonly headers: HttpHeaders;
   constructor() {
      this.headers = new HttpHeaders().set('Accept', 'application/json');
   }
}
